import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/facebook.svg'
import _imports_1 from '@/assets/images/dribbble.svg'
import _imports_2 from '@/assets/images/instagram.svg'
import _imports_3 from '@/assets/images/behance.svg'
import _imports_4 from '@/assets/images/figma.svg'
import _imports_5 from '@/assets/images/google2.svg'


const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "card-body p-4" }, [
      _createElementVNode("div", { class: "mb-3 mb-lg-30" }, [
        _createElementVNode("h3", { class: "mb-0" }, "Channels")
      ]),
      _createElementVNode("ul", { class: "ps-0 mb-0 list-unstyled" }, [
        _createElementVNode("li", { class: "mb-3 pb-3 border-bottom" }, [
          _createElementVNode("div", { class: "d-flex align-items-center justify-content-between" }, [
            _createElementVNode("div", { class: "flex-shrink-0" }, [
              _createElementVNode("div", { class: "d-flex" }, [
                _createElementVNode("img", {
                  src: _imports_0,
                  style: {"width":"31px"},
                  alt: "facebook"
                }),
                _createElementVNode("div", { class: "ms-3" }, [
                  _createElementVNode("h4", { class: "mb-0 fs-14 fw-semibold lh-1" }, "Facebook"),
                  _createElementVNode("span", { class: "fs-12" }, "Community")
                ])
              ])
            ]),
            _createElementVNode("div", { class: "flex-grow-1 ms-3" }, [
              _createElementVNode("div", { class: "d-flex align-items-center justify-content-end" }, [
                _createElementVNode("div", {
                  class: "progress-responsive",
                  style: {"width":"120px"}
                }, [
                  _createElementVNode("div", {
                    class: "progress rounded-pill",
                    style: {"height":"8px","background-color":"#dde4ff"},
                    role: "progressbar",
                    "aria-label": "Example with label",
                    "aria-valuenow": "50",
                    "aria-valuemin": "0",
                    "aria-valuemax": "100"
                  }, [
                    _createElementVNode("div", {
                      class: "progress-bar rounded-pill",
                      style: {"width":"50%","height":"8px","background-color":"#757dff"}
                    })
                  ])
                ]),
                _createElementVNode("span", { class: "count text-body ms-3 fs-12" }, "50%")
              ])
            ])
          ])
        ]),
        _createElementVNode("li", { class: "mb-3 pb-3 border-bottom" }, [
          _createElementVNode("div", { class: "d-flex align-items-center justify-content-between" }, [
            _createElementVNode("div", { class: "flex-shrink-0" }, [
              _createElementVNode("div", { class: "d-flex" }, [
                _createElementVNode("img", {
                  src: _imports_1,
                  style: {"width":"31px"},
                  alt: "dribbble"
                }),
                _createElementVNode("div", { class: "ms-3" }, [
                  _createElementVNode("h4", { class: "mb-0 fs-14 fw-semibold lh-1" }, "Dribbble"),
                  _createElementVNode("span", { class: "fs-12" }, "Community")
                ])
              ])
            ]),
            _createElementVNode("div", { class: "flex-grow-1 ms-3" }, [
              _createElementVNode("div", { class: "d-flex align-items-center justify-content-end" }, [
                _createElementVNode("div", {
                  class: "progress-responsive",
                  style: {"width":"120px"}
                }, [
                  _createElementVNode("div", {
                    class: "progress rounded-pill",
                    style: {"height":"8px","background-color":"#daebff"},
                    role: "progressbar",
                    "aria-label": "Example with label",
                    "aria-valuenow": "75",
                    "aria-valuemin": "0",
                    "aria-valuemax": "100"
                  }, [
                    _createElementVNode("div", {
                      class: "progress-bar rounded-pill",
                      style: {"width":"75%","height":"8px","background-color":"#5da8ff"}
                    })
                  ])
                ]),
                _createElementVNode("span", { class: "count text-body ms-3 fs-12" }, "75%")
              ])
            ])
          ])
        ]),
        _createElementVNode("li", { class: "mb-3 pb-3 border-bottom" }, [
          _createElementVNode("div", { class: "d-flex align-items-center justify-content-between" }, [
            _createElementVNode("div", { class: "flex-shrink-0" }, [
              _createElementVNode("div", { class: "d-flex" }, [
                _createElementVNode("img", {
                  src: _imports_2,
                  style: {"width":"31px"},
                  alt: "instagram"
                }),
                _createElementVNode("div", { class: "ms-3" }, [
                  _createElementVNode("h4", { class: "mb-0 fs-14 fw-semibold lh-1" }, "Instagram"),
                  _createElementVNode("span", { class: "fs-12" }, "Reel")
                ])
              ])
            ]),
            _createElementVNode("div", { class: "flex-grow-1 ms-3" }, [
              _createElementVNode("div", { class: "d-flex align-items-center justify-content-end" }, [
                _createElementVNode("div", {
                  class: "progress-responsive",
                  style: {"width":"120px"}
                }, [
                  _createElementVNode("div", {
                    class: "progress rounded-pill",
                    style: {"height":"8px","background-color":"#ffe8d4"},
                    role: "progressbar",
                    "aria-label": "Example with label",
                    "aria-valuenow": "30",
                    "aria-valuemin": "0",
                    "aria-valuemax": "100"
                  }, [
                    _createElementVNode("div", {
                      class: "progress-bar rounded-pill",
                      style: {"width":"30%","height":"8px","background-color":"#fe7a36"}
                    })
                  ])
                ]),
                _createElementVNode("span", { class: "count text-body ms-3 fs-12" }, "30%")
              ])
            ])
          ])
        ]),
        _createElementVNode("li", { class: "mb-3 pb-3 border-bottom" }, [
          _createElementVNode("div", { class: "d-flex align-items-center justify-content-between" }, [
            _createElementVNode("div", { class: "flex-shrink-0" }, [
              _createElementVNode("div", { class: "d-flex" }, [
                _createElementVNode("img", {
                  src: _imports_3,
                  style: {"width":"31px"},
                  alt: "behance"
                }),
                _createElementVNode("div", { class: "ms-3" }, [
                  _createElementVNode("h4", { class: "mb-0 fs-14 fw-semibold lh-1" }, "Behance"),
                  _createElementVNode("span", { class: "fs-12" }, "Community")
                ])
              ])
            ]),
            _createElementVNode("div", { class: "flex-grow-1 ms-3" }, [
              _createElementVNode("div", { class: "d-flex align-items-center justify-content-end" }, [
                _createElementVNode("div", {
                  class: "progress-responsive",
                  style: {"width":"120px"}
                }, [
                  _createElementVNode("div", {
                    class: "progress rounded-pill",
                    style: {"height":"8px","background-color":"#f3e8ff"},
                    role: "progressbar",
                    "aria-label": "Example with label",
                    "aria-valuenow": "80",
                    "aria-valuemin": "0",
                    "aria-valuemax": "100"
                  }, [
                    _createElementVNode("div", {
                      class: "progress-bar rounded-pill",
                      style: {"width":"80%","height":"8px","background-color":"#bf85fb"}
                    })
                  ])
                ]),
                _createElementVNode("span", { class: "count text-body ms-3 fs-12" }, "80%")
              ])
            ])
          ])
        ]),
        _createElementVNode("li", { class: "mb-3 pb-3 border-bottom" }, [
          _createElementVNode("div", { class: "d-flex align-items-center justify-content-between" }, [
            _createElementVNode("div", { class: "flex-shrink-0" }, [
              _createElementVNode("div", { class: "d-flex" }, [
                _createElementVNode("img", {
                  src: _imports_4,
                  style: {"width":"31px"},
                  alt: "figma"
                }),
                _createElementVNode("div", { class: "ms-3" }, [
                  _createElementVNode("h4", { class: "mb-0 fs-14 fw-semibold lh-1" }, "Figma"),
                  _createElementVNode("span", { class: "fs-12" }, "Community")
                ])
              ])
            ]),
            _createElementVNode("div", { class: "flex-grow-1 ms-3" }, [
              _createElementVNode("div", { class: "d-flex align-items-center justify-content-end" }, [
                _createElementVNode("div", {
                  class: "progress-responsive",
                  style: {"width":"120px"}
                }, [
                  _createElementVNode("div", {
                    class: "progress rounded-pill",
                    style: {"height":"8px","background-color":"#daebff"},
                    role: "progressbar",
                    "aria-label": "Example with label",
                    "aria-valuenow": "50",
                    "aria-valuemin": "0",
                    "aria-valuemax": "100"
                  }, [
                    _createElementVNode("div", {
                      class: "progress-bar rounded-pill",
                      style: {"width":"50%","height":"8px","background-color":"#5da8ff"}
                    })
                  ])
                ]),
                _createElementVNode("span", { class: "count text-body ms-3 fs-12" }, "50%")
              ])
            ])
          ])
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("div", { class: "d-flex align-items-center justify-content-between" }, [
            _createElementVNode("div", { class: "flex-shrink-0" }, [
              _createElementVNode("div", { class: "d-flex" }, [
                _createElementVNode("img", {
                  src: _imports_5,
                  style: {"width":"31px"},
                  alt: "google"
                }),
                _createElementVNode("div", { class: "ms-3" }, [
                  _createElementVNode("h4", { class: "mb-0 fs-14 fw-semibold lh-1" }, "Google"),
                  _createElementVNode("span", { class: "fs-12" }, "SEO & PPC")
                ])
              ])
            ]),
            _createElementVNode("div", { class: "flex-grow-1 ms-3" }, [
              _createElementVNode("div", { class: "d-flex align-items-center justify-content-end" }, [
                _createElementVNode("div", {
                  class: "progress-responsive",
                  style: {"width":"120px"}
                }, [
                  _createElementVNode("div", {
                    class: "progress rounded-pill",
                    style: {"height":"8px","background-color":"#d8ffc8"},
                    role: "progressbar",
                    "aria-label": "Example with label",
                    "aria-valuenow": "20",
                    "aria-valuemin": "0",
                    "aria-valuemax": "100"
                  }, [
                    _createElementVNode("div", {
                      class: "progress-bar rounded-pill",
                      style: {"width":"20%","height":"8px","background-color":"#58f229"}
                    })
                  ])
                ]),
                _createElementVNode("span", { class: "count text-body ms-3 fs-12" }, "20%")
              ])
            ])
          ])
        ])
      ])
    ], -1)
  ])))
}